// Module
var code = `<textarea></textarea>
<div class="error" ng-if="!\$ctrl.isInitialized">
  SQL editor failed to load
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/sql-editor/sql-editor.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;